<template> </template>

<script>
import apiMixins from "@/mixins/apiMixins";
export default {
  mixins: [apiMixins],
  methods: {
    async goToUserDashboard() {
      const urlDashboardUser = this.$session.get("urlDashboardUser");
      if (!urlDashboardUser) {
        const userDashboardData = await this.requestApiData(
          "/user/panel",
          "get"
        );
        this.$session.set("urlDashboardUser", userDashboardData.data.url);
        window.location.href = userDashboardData.data.url;
      } else {
        window.location.href = urlDashboardUser;
      }
    }
  },
  mounted() {
    this.goToUserDashboard();
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/RedirectToDashboard.vue